import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import script from './HseTag.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g({tag:"component",staticClass:"hse-Tag",class:( _obj = {}, _obj[("hse-Tag_size_" + _vm.size)] = _vm.size, _obj['hse-Tag_disabled'] =  _vm.disabled, _obj['hse-Tag_focused'] =  _vm.focused, _obj['hse-Tag_hovered'] =  _vm.hovered, _obj['hse-Tag_clickable'] =  _vm.clickable, _obj['hse-Tag_selected'] =  _vm.selected, _obj )},_vm.$listeners),[_vm._t("left-icon",[(_vm.leftIcon)?_c('HseIcon',{class:_vm.leftIconClassName,attrs:{"size":"small","icon":_vm.leftIcon}}):_vm._e()],null,{ class: _vm.leftIconClassName }),_vm._v(" "),_c('span',{class:_vm.classes.children},[_vm._t("default")],2),_vm._v(" "),_vm._t("right-icon",[(_vm.rightIcon)?_c('HseIcon',{class:_vm.rightIconClassName,attrs:{"size":"small","icon":_vm.rightIcon}}):_vm._e()],null,{ class: _vm.rightIconClassName })],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
